import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedMaintenanceScheduleSelector($companyId: ID!, $id: ID) {
    maintenanceSchedules(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        details
        summary
        maintenanceType {
          id
          name
        }
      }
    }
  }
`

export const Query = gql`
  query MaintenanceScheduleSelector(
    $companyId: ID!,
    $filters: MaintenanceScheduleFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    maintenanceSchedules(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        details
        summary
        repeatPeriod
        maintenanceType {
          id
          name
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
